<template>
  <section class="addressEdit">
	<header-com/>
	<ul class="f28">
	  <li v-for="(item,index) in list" :key="index" @click="clickItem(item)">
		<h3 class="f32 bold">{{item.title}}</h3>
		<div v-if="item.title ==='所在地区'">
		  <input v-show="!complateAddr" :type="item.type || 'text'"
				 disabled :placeholder="item.placeholder">
		  <p v-show="complateAddr" >{{complateAddr}}</p>
		</div>
		<div v-else>
		  <input  :type="item.type || 'text'"
				  @blur="inputBlur"
				  :placeholder="item.placeholder" v-model="item.data">
		</div>
	  </li>
	</ul>
	<div class="setDefault">
	  <p class="f28 bold">设置默认地址</p>
	  <my-switch :isActive="isDefault"
				 @changeSwitch="changeSwitch"></my-switch>
	</div>
	
	<city-selecter ref="citySelecter" @city-change="selectCity"/>
	
	<div class="g-fixed-bottom">
	  <button class="primary" size="large" @click="submit">确认</button>
	</div>
	
  </section>
</template>

<script>
  import citySelecter from './citySelecter'
  import addressApi from '@/api/address'
  import publicObj from '@/utils/public'
  export default {
    name: 'addressEdit',
    components: {citySelecter},
    data() {
      return {
        list:[
		  {title:'收货人',placeholder:'填写姓名',data:'',key:'consignee'},
		  {title:'联系方式',placeholder:'手机号/固话/分机号等',data:'',key:'mobile',type:'tel'},
		  {title:'所在地区',placeholder:'如：北京 朝阳区',data:'',key:'cityList'},
		  {title:'详细地址',placeholder:'街道/小区/楼牌号/单元室等',data:'',key:'detail'},
		],
		isDefault:true,
        cityList:[]
	  }
    },
    watch: {},
    computed: {
      defaultAddCode() {
        return this.$store.state.defaultAddCode
      },
      // 完整地址
      complateAddr() {
        // console.log(this.cityList)
        return this.cityList.reduce((t, n) => t += n.name, '')
      },
      // url地址id
      addressId() {
        return this.$route.query.id || null
      }
	},
    created() {
      if (this.addressId) this.byIdGetAddress()
    },
    mounted() {
    },
    methods: {
      inputBlur(){
        publicObj.IPhoneXHack()
      },
      clickItem(item) {
        if(item.title === '所在地区'){
          this.$refs['citySelecter'].show()
        }
	  },
      selectCity(cityList){
		this.cityList = [...cityList]
	  },
      changeSwitch(){
        this.isDefault = !this.isDefault
	  },
      // 根据指定id查地址
      byIdGetAddress() {
        addressApi.byIdGetAddress(this.addressId)
            .then(res => {
              const {detail, city, country, province, mobile, consignee, prefer, countryId, cityId, provinceId} = res
              this.list[0].data = consignee;
              this.list[1].data = mobile;
              this.list[3].data = detail;
			  prefer === this.defaultAddCode ?
				  this.isDefault = true
				  : this.isDefault = false
              this.cityList = [{
			    id: provinceId,
                name: province
			  }, {
			    id: cityId,
                name: city
              },
				{
                  id: countryId,
                  name: country
                }]
            })
      },
      // 提交
      submit() {
        let params = {}
        for(let i in this.list){
          if(this.list[i].title !== '所在地区'){
            if(!this.list[i].data){
              this.$toast(`${this.list[i].title}不能为空`)
              return
			}else {
              params[this.list[i].key] = this.list[i].data
            }
		  }else {
            if (this.cityList.length === 0) {
              this.$toast(`请选择${this.list[i].title}`)
              return
            }
		  }
		}
        params.provinceId = this.cityList[0].id
        params.cityId = this.cityList[1].id
        params.countryId = this.cityList[2] && this.cityList[2].id
        params.prefer = this.isDefault ? 2 : 1;
        this.setAddress(params)
            .then(res => {
              this.$router.back()
            })
      },
      setAddress(params) {
        if (!this.addressId){
          return addressApi.addAddress(params)
		} else {
          const putAddress = addressApi.putAddress(this.addressId);
          return putAddress(params)
		}
      },
	}

  }
</script>

<style lang="scss" scoped>
.addressEdit{
  padding: 70px 40px 120px;
  ul{
	li{
	  h3{
		padding: 50px 0;
		line-height: 44px;
	  }
	  div{
		border-bottom: $light-border;
		padding-bottom: 20px;
	  }
	  input{
		width: 100%;
		padding: 14px 0;
		height: 40px;
		line-height: 40px;
	  }
	}
  }
  .setDefault{
	color: $brand-color;
	display: flex;
	justify-content: space-between;
	padding: 44px 0;
	line-height: 48px;
  }
}
</style>
